<div class="information-image-container">
  <div class="switch-button-mobile-wrapper global-transition" *ngIf="$any(currentCampaign)?.capture_mobile_url">
    <button (click)="activeBtnHandler()" [ngClass]="{'active' : !mobilePreview}" class="switch-button-mobile global-transition">
      <div class="switch-button-mobile-content">
        <nb-icon [style.font-size.px]="14" icon="device-desktop" pack="icomoon"></nb-icon>
        <span>Desktop</span>
      </div>
    </button>
    <button (click)="activeBtnHandler()" [ngClass]="{'active' : mobilePreview}" class="switch-button-mobile global-transition">
      <div class="switch-button-mobile-content">
        <nb-icon [style.font-size.px]="14" icon="device-mobile" pack="icomoon"></nb-icon>
        <span>Mobile</span>
      </div>
    </button>
  </div>
  <div class="campaign-image-container" [ngClass]="{'mobile-preview' : mobilePreview}">
    <img [src]="mobilePreview ? $any(currentCampaign)?.capture_mobile_url : currentCampaign?.capture_url" alt="logo" default="{{ defaultImage }}" />
  </div>
  <div class="logo-container">
    <img [src]="currentCampaign?.logo ?? ''" alt="logo" default="{{ defaultImage }}" />
  </div>
  <div class="novelity-wrapper novelity-wrapper-position" *ngIf="currentCampaign?.is_new">
    <p>New</p>
  </div>
  <div class="switch-btn-desktop global-transition" *ngIf="$any(currentCampaign)?.capture_mobile_url">
    <button (click)="activeBtnHandler()" [ngClass]="{'active' : !mobilePreview}" class="btn switch-icon global-transition">
      <nb-icon icon="device-desktop" pack="icomoon"></nb-icon>
    </button>
    <button (click)="activeBtnHandler()" [ngClass]="{'active' : mobilePreview}" class="btn switch-icon global-transition">
      <nb-icon icon="device-mobile" pack="icomoon"></nb-icon>
    </button>
  </div>
  <div class="options">
    <ng-container *ngIf="currentCampaign?.live">
      <div class="option live">
        <nb-icon icon="live" pack="icomoon"></nb-icon>
      </div>
    </ng-container>
    <ng-container *ngIf="currentCampaign?.recommended">
      <div class="option recommended">
        <nb-icon icon="star-circle" pack="icomoon"></nb-icon>
      </div>
    </ng-container>
    <ng-container *ngIf="currentCampaign?.beginner">
      <div class="option beginner">
        <i class="fas fa-rocket"></i>
      </div>
    </ng-container>
  </div>
</div>
